<template>
    <div>
        <div class="app-title" v-if="isRouteIn">
            <em-view-title key="viewTitle"
                           :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <div :class="(isRouteIn ? 'app-content' : '') + (isFullscreen ? 'full-screen overflow-auto' : '')"
             @dblclick="handleDbClick">
            <b-overlay :show="loading" rounded="sm">
                <pdf-viewer :source="url" class="m-auto"></pdf-viewer>
            </b-overlay>
        </div>

        <div class="back-cover" v-if="isFullscreen"></div>

        <div class="position-fixed right mr-4 m-tb-auto d-flex flex-column" v-if="isFullscreen" style="z-index: 10000">
            <el-slider
                v-model="scaleValue"
                vertical
                :step="2" :min="1"
                :format-tooltip="formatTooltip"
                height="200px">
            </el-slider>
            <AvatarButton icon="el-icon-refresh-left" title="重置" @btnClick="resetScaleValue"
                          class="m-auto"></AvatarButton>
        </div>
    </div>
</template>

<script>
import emCommonListMixin from "@/mixin/em/common/list";
import AvatarButton from "@/components/echarts-part/CalendarShift/cells/stuffs/AvatarButton";

export default {
    name: 'previewPdfV2',
    components: {AvatarButton},
    mixins: [emCommonListMixin],
    props: {
        src: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            url: "",
            numPages: 1,
            loading: true,
            isFullscreen: false,
            scaleValue: 0,
        }
    },
    computed: {
        isRouteIn() {
            return this.src === '' && this.routeSrc !== undefined;
        },
        routeSrc() {
            return this.$route.query.src;
        }
    },
    mounted() {
        this.resetScaleValue();
        this.getSrc();
    },
    methods: {
        getSrc() {
            let str = this.src;
            if (str === '') {
                if (this.routeSrc === undefined) {
                    this.$message.error("没有有效的路径");
                    this.$router.go(-1);
                } else {
                    str = process.env.VUE_APP_EM_GATEWAY_URL + decodeURIComponent(String(this.routeSrc));
                }
            }
            if (str !== undefined) {
                this.url = str;
                this.loading = false;
            }
        },
        handleDbClick() {
            if (!this.isRouteIn) {
                this.isFullscreen = !this.isFullscreen;
                if (!this.isFullscreen) {
                    this.resetScaleValue();
                }
            }
        },
        formatTooltip(val) {
            return val * 5 + '%';
        },
        resetScaleValue() {
            this.scaleValue = 20;
        }
    }
}
</script>

<style>
.overflow-auto {
    overflow: auto;
}

.vue-pdf-embed > div {
    margin-bottom: 8px;
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}
</style>
